import { DropzoneTableViewColumn } from "@/pages/sources/components/dropzone/types";

export const DROPZONE_TABLE_VIEW_COLUMN_WIDTH_MAP: Record<
  DropzoneTableViewColumn,
  number | undefined
> = {
  [DropzoneTableViewColumn.FILE_NAME]: undefined,
  [DropzoneTableViewColumn.FILE_SIZE]: 74,
  [DropzoneTableViewColumn.FILE_ACTIONS]: 74,
};

export const DROPZONE_TABLE_VIEW_COLUMNS: DropzoneTableViewColumn[] = [
  DropzoneTableViewColumn.FILE_NAME,
  DropzoneTableViewColumn.FILE_SIZE,
  DropzoneTableViewColumn.FILE_ACTIONS,
];

export const DROPZONE_TABLE_VIEW_COLUMN_TO_LABEL_MAP: Record<DropzoneTableViewColumn, string> = {
  [DropzoneTableViewColumn.FILE_NAME]: "File name",
  [DropzoneTableViewColumn.FILE_SIZE]: "Size",
  [DropzoneTableViewColumn.FILE_ACTIONS]: "",
};
